






























    import { Component, Prop, Watch } from "../../../Infrastructure/CorBase/CoreBase";
    import GlobalSearchListBase from "./GlobalSearchListBase"; 

    @Component
    export default class GlobalSearchList extends GlobalSearchListBase {

        created() {
            //TODO prava
            super.initializeRights('COR_Tag_Create', 'COR_Tag_Delete', 'COR_Tag_Read', 'COR_Tag_Update');
            super.created();
            this.setFilterGlobalSerch(this.$store.state.globalSearch);
   
        };


        globalSearch = '';
        @Watch('$store.state.globalSearch')
        onPropertyStoreGlobalSearch(value: string, oldValue: string) {
            if (value != oldValue) {
              //TODO OBNOVIT po odstranei chyby
                this.setFilterGlobalSerch(value);
            }
        }

        setFilterGlobalSerch(value: string) {
            this.globalSearch = value;
            var filterSearch = this.filters.filter((c: any) => c.key == 'search')[0];
            if (filterSearch.value != value) {
                filterSearch.value = value;
   
                if (this.$refs.globalSearch != undefined) {
                    // @ts-ignore
                    this.$refs.globalSearch.changeParamTable();
                 }
            }
        }

        //TOHLE NECHAT maxilane presun  do base

        selectItemObject(item: any) {
            super.selectItemObjectBase(item);
			
		}

        oldParam = null;
        changeParam(params: any) {
            if (this.oldParam != params) {
                super.changeParamBase(params);
                if (this.$refs.globalSearch != undefined) {
                    // @ts-ignore
                    this.$refs.globalSearch.filterItemsRest();
                    this.oldParam = params;
                }
                
               
            }
        }

        loadFilters(value: any) {
            super.loadFilters(value);
        }
            //TODO zatim nepouzito
  //      createNewClick(elementId: any) { super.createNewClick(elementId); }
		//detailClick(elementId: any) { super.detailClick(elementId); }
		//deleteClick(elementId: any) { this.deleteClick(elementId) }
    };
